import { useState } from 'react';

// A counter rather than MUI's useId: on React 17 that id only arrives after an effect, which
// would leave the first frame's aria-controls dangling. This app never server-renders.
let uniqueIdCount = 0;

/** A document-unique id with the given prefix, stable for the life of the component. */
export const useUniqueId = (prefix: string) =>
  useState(() => `${prefix}-${(uniqueIdCount += 1)}`)[0];

/** Ids for a bulk-actions button and the menu it controls. */
export const useBulkActionIds = () => {
  const id = useUniqueId('bulk-actions');
  return { buttonId: `${id}-button`, menuId: `${id}-menu` };
};

/** Ids for an AccordionSummary, which MUI also uses to name the panel's region. */
export const useAccordionIds = () => {
  const id = useUniqueId('accordion');
  return { id: `${id}-summary`, 'aria-controls': `${id}-region` };
};
